/* global $, API */

import { Controller } from 'stimulus';

const $countrySelector = $('.js-country-select');
const $otherAddressCheckbox = $('.js-invoice-address-check');
const $shippingMethods = $('.js-shipping-methods');

class ShippingForCountryController extends Controller {
  connect() {
    $('.js-address').on('change', '.js-country-select, .js-shipping-country-select, .js-delivery-address-check', (e) => {
      let select = $countrySelector;

      if ($otherAddressCheckbox[0].checked && $(e.currentTarget).hasClass('js-country-select')) {
        return;
      }

      if ($otherAddressCheckbox[0].checked) {
        select = $('.js-shipping-country-select');
      }

      const value = select.val();

      this.getShippingMethods(value)
        .then(data => this.outputShippingMethods(data.shippingMethods))
        .then(() => this.updateSummaryPrices());
    });
  }

  // eslint-disable-next-line class-methods-use-this
  getShippingMethods(country) {
    return $.ajax({
      url: API.shippingMethods,
      type: 'GET',
      data: {
        country,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  outputShippingMethods(shippingMethods) {
    $shippingMethods.html(shippingMethods);
  }

  updateSummaryPrices() {
    const shippingControllerEl = document.querySelector('[data-controller*="shipping"]');
    const shippingController = this.application.getControllerForElementAndIdentifier(shippingControllerEl, 'shipping');

    shippingController.handleShippingCosts();
  }
}

export default ShippingForCountryController;
